import { css } from "styled-components";

/**
 * 상세 페이지 이미지 슬라이더 PC 화살표 스타일
 * - 공지/AS/이행 상세 페이지에서 공통 사용
 */
export const pcDetailSliderArrowStyles = css`
  ${/* 화살표 위치 및 크기 조정 */ ""}
  .slick-prev,
  .slick-next {
    z-index: 10;
    width: 40px;
    height: 40px;
    &:before {
      font-size: 40px;
      color: #000;
    }
  }
  .slick-prev {
    left: 20px;
  }
  .slick-next {
    right: 20px;
  }
`;

/**
 * 전체화면 이미지 모달 PC 스타일
 * - 공지/AS/이행 상세 페이지의 전체화면 모달에서 공통 사용
 */
export const pcModalSliderStyles = css`
  @media (min-width: 769px) {
    .slick-list {
      background: #000;
    }

    .img-box > img {
      max-width: 90vw;
      max-height: 90vh;
      object-fit: contain;
      justify-self: center;
    }

    .slick-dots {
      bottom: 50px;
    }

    .slick-prev,
    .slick-next {
      z-index: 10;
      width: 40px;
      height: 40px;
      &:before {
        font-size: 40px;
        opacity: 0.8;
      }
      &:hover:before {
        opacity: 1;
      }
    }
    .slick-prev {
      left: 20px;
    }
    .slick-next {
      right: 20px;
    }
  }
`;

/**
 * 전체화면 이미지 모달 배경 PC 스타일
 */
export const pcModalBackgroundStyles = css`
  @media (min-width: 769px) {
    background: #000;
  }
`;
